"use client"

// Este componente ya no es necesario ya que HeroUI maneja los toasts automáticamente
// Se mantiene para compatibilidad pero no renderiza nada
// El ToastProvider ya está en providers.tsx
export function Toaster() {
  // HeroUI ToastProvider maneja los toasts automáticamente
  // No necesitamos renderizar nada aquí
  return null;
}
